export class Fixtures  {
    public modules = [
      {
          id: 1,
          title: 'Main concepts of nuclear physics. Fundamentals of reactor physics',
          description: 'This module describes the main concepts of nuclear physics and fundamentals of reactor physics.',
          lectures: [
          {
              position: 1,
              title: 'Discovery of Nucleus',
              description: '',
          },
          {
              position: 2,
              title: 'Discovery of Neutron',
              description: '',
          },
          {
              position: 3,
              title: 'Binding energy',
              description: '',
          },
          {
              position: 4,
              title: 'Neutron cross-sections',
              description: '',
          },
          {
              position: 5,
              title: 'Principle of nuclear reactor',
              description: '',
          }
      ]},
      {
          id: 2,
          title: 'Engineering fundamentals of nuclear power generation. Basics of VVER technology',
          description: 'This module describes the basics of nuclear safety in terms of engineering fundamentals of nuclear power generation',
          lectures: [
          {
              position: 1,
              title: 'Structural materials of nuclear power reactors',
              description: '',
          },
          {
              position: 2,
              title: 'Concept of fuel burn up',
              description: '',
          },
          {
              position: 3,
              title: 'Plutonium accumulation in nuclear reactor',
              description: '',
          },
          {
              position: 4,
              title: 'Basics of safe operation of nuclear power reactors: reactivity effects',
              description: '',
          },
          {
              position: 5,
              title: 'Comparison of specific characteristics of VVER vs PWR',
              description: '',
          },
          {
              position: 6,
              title: 'Advanced nuclear fuel types for nuclear power reactors in Russia',
              description: '',
          },
      ]},
      {id: 3,
          title: 'Specifics of VVER (AES-2006) Reactor facility',
          description: 'This module describes the specifics of VVER-1200 reactor facility used in AES-2006',
          lectures: [
          {
              position: 1,
              title: 'Introduction to VVER Technology',
              description: '',
          },
          {
              position: 2,
              title: 'Reactor Technical Specifications',
              description: '',
          },
          {
              position: 3,
              title: 'Reactor Vessel',
              description: '',
          },
          {
              position: 4,
              title: 'VVER Fuel',
              description: '',
          },
          {
              position: 5,
              title: 'VVER Components',
              description: '',
          },
          {
              position: 6,
              title: 'Introduction to Natural Circulation',
              description: '',
          },
          {
              position: 7,
              title: 'VVER Operation',
              description: '',
          }
      ]},
      {id: 4,
          title: 'Design Solutions of AES-2006 reactor auxiliary system and turbine part',
          description: 'This module describes design solutions of AES-2006 mechanical part in terms of main systems of the primary circuit, tubine island and handling of spent nuclear fuel]',
          lectures: [
          {
              position: 1,
              title: 'Main Systems of the Primary Circuit',
              description: '',
          },
          {
              position: 2,
              title: 'Operation of the Auxiliary Systems under Normal Operating Conditions',
              description: '',
          },
          {
              position: 3,
              title: 'Turbine Island',
              description: '',
          },
          {
              position: 4,
              title: 'Handling of Spent Nuclear Fuel',
              description: '',
          }
      ]},
        {id: 5,
            title: 'VVER (AES-2006) Safety Systems',
            description: 'This module describes AES-2006 systems design in terms of VVER safety systems',
            lectures: [
            {
                position: 1,
                title: 'Safety fundamentals for NPPs',
                description: '',
            },
            {
                position: 2,
                title: 'Design and Safety Functions',
                description: '',
            },
            {
                position: 3,
                title: 'VVER Safety Systems',
                description: '',
            },
            {
                position: 4,
                title: 'А. Reactivity control',
                description: '',
            },
            {
                position: 5,
                title: 'В. Heat removal from nuclear fuel',
                description: '',
            },
            {
                position: 6,
                title: 'С. Localization of activity',
                description: '',
            }
        ]}
    ];
    public tests = [
        {
            id: 'entrance',
            title: 'Entrance test',
            questions: [
                {
                    id: 1,
                    text: 'Which Project is the reference project for European AES-2006?',
                    answers: [
                        {
                            id: 1,
                            text: 'AES-91',
                            isRight: false,
                            questionId: 1
                        },
                        {
                            id: 2,
                            text: 'VVER-1000/320',
                            isRight: false,
                            questionId: 1
                        },
                        {
                            id: 3,
                            text: 'AES-2006 (Leningrad NPP-2)',
                            isRight: true,
                            questionId: 1
                        },
                        {
                            id: 4,
                            text: 'VVER-TOI',
                            isRight: false,
                            questionId: 1
                        }
                    ]
                },
                {
                    id: 2,
                    text: 'List the main buildings on AES-2006 general plan',
                    answers: [
                        {
                            id: 3,
                            text: 'Reactor and turbine buildings, Control building, Auxiliary building and Safety building',
                            isRight: true,
                            questionId: 2
                        },
                        {
                            id: 4,
                            text: 'Reactor building, Control building, Safety building',
                            isRight: false,
                            questionId: 2
                        },
                        {
                            id: 5,
                            text: 'Reactor and turbine buildings, Safety building',
                            isRight: false,
                            questionId: 2
                        },
                        {
                            id: 6,
                            text: 'Reactor building, Control building, Safety building',
                            isRight: false,
                            questionId: 2
                        }
                    ]
                },
                {
                    id: 3,
                    text: 'What building at NPP holds this equipment: Generator, Deaerator, Regenerators?',
                    answers: [
                        {
                            id: 7,
                            text: 'Reactor building',
                            isRight: false,
                            questionId: 3
                        },
                        {
                            id: 8,
                            text: 'Turbine building',
                            isRight: true,
                            questionId: 3
                        },
                        {
                            id: 9,
                            text: 'Safety building',
                            isRight: false,
                            questionId: 3
                        },
                        {
                            id: 10,
                            text: 'Auxiliary building',
                            isRight: false,
                            questionId: 3
                        },
                        {
                            id: 11,
                            text: 'Control building',
                            isRight: false,
                            questionId: 3
                        }
                    ]
                },
                {
                    id: 4,
                    text: 'How many coolant cycles are used in AES-2006 for electricity production?',
                    answers: [
                        {
                            id: 12,
                            text: 'One (primary cycle)',
                            isRight: false,
                            questionId: 4
                        },
                        {
                            id: 13,
                            text: 'Two (primary and secondary)',
                            isRight: true,
                            questionId: 4
                        },
                        {
                            id: 14,
                            text: 'Three (primary, secondary and intermediate)',
                            isRight: false,
                            questionId: 4
                        },
                        {
                            id: 15,
                            text: 'No cycles are used – it’s direct energy conversion',
                            isRight: false,
                            questionId: 4
                        }
                    ]
                }
            ]
        },
        {
            id: 'final',
            title: 'Final test',
            questions: [
                {
                    id: 5,
                    text: 'What kind of pump is used to transfer the secondary circuit coolant?',
                    answers: [
                        {
                            id: 16,
                            text: 'Primary circuit pump – Reactor coolant pump',
                            isRight: false,
                            questionId: 5
                        },
                        {
                            id: 17,
                            text: 'Circulation pump',
                            isRight: false,
                            questionId: 5
                        },
                        {
                            id: 18,
                            text: 'Feed water pump',
                            isRight: true,
                            questionId: 5
                        },
                        {
                            id: 19,
                            text: 'Emergency pump',
                            isRight: false,
                            questionId: 5
                        }
                    ]
                },
                {
                    id: 6,
                    text: 'What is the connection between the primary and secondary circuit coolants?',
                    answers: [
                        {
                            id: 20,
                            text: 'They are connected indirectly through the walls of pipes of the steam generator',
                            isRight: true,
                            questionId: 6
                        },
                        {
                            id: 21,
                            text: 'They are not connected',
                            isRight: false,
                            questionId: 6
                        },
                        {
                            id: 22,
                            text: 'They are connected directly inside the steam generator',
                            isRight: false,
                            questionId: 6
                        }
                    ]
                },
                {
                    id: 7,
                    text: 'What equipment is used to produce electricity from heat? Place the items in the right order.',
                    answers: [
                        {
                            id: 23,
                            text: 'Reactor vessel, Steam generator, Steam turbine, Electric generator, Transformer',
                            isRight: true,
                            questionId: 7
                        },
                        {
                            id: 24,
                            text: 'Steam generator, Reactor vessel, Electric generator, Steam turbine, Transformer',
                            isRight: false,
                            questionId: 7
                        },
                        {
                            id: 25,
                            text: 'Reactor vessel, Steam generator, Transformer, Steam turbine, Electric generator',
                            isRight: false,
                            questionId: 7
                        }
                    ]
                },
                {
                    id: 8,
                    text: 'What type of heat exchangers can be used for feed water cooling?',
                    answers: [
                        {
                            id: 26,
                            text: 'Only cooling ponds',
                            isRight: false,
                            questionId: 8
                        },
                        {
                            id: 27,
                            text: 'Only cooling towers',
                            isRight: false,
                            questionId: 8
                        },
                        {
                            id: 28,
                            text: 'Only sea water',
                            isRight: false,
                            questionId: 8
                        },
                        {
                            id: 29,
                            text: 'Cooling Towers, Cooling ponds, Sea water, Spray/Sprinkler ponds',
                            isRight: true,
                            questionId: 8
                        }
                    ]
                }
            ]
        }
    ];
}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/fixtures.ts